import HighlightText from "@/app/(core)/(other)/about/components/HighlightText";
import { getInitials } from "@/lib/strapi/formatters";
import { Avatar, Card, rgba, Text, useMantineTheme } from "@mantine/core";
import clsx from "clsx";
import classes from "./testimonial-card.module.css";

interface TestimonialCardProps {
  quote: string;
  highlightText: string[];
  name: string;
  role: string;
  avatarUrl?: string;
  hideOnMobile?: boolean;
}

export default function TestimonialCard({
  quote,
  highlightText,
  name,
  role,
  avatarUrl,
  hideOnMobile = false,
}: TestimonialCardProps) {
  const theme = useMantineTheme();

  return (
    <Card
      className={clsx(classes.card, hideOnMobile && classes.hideOnMobile)}
    >
      <div className={classes.quote}>
        <HighlightText
          className={classes.quoteText}
          text={quote}
          highlightText={highlightText}
          textColor={theme.colors.dark[4]}
          backgroundHighlightColor={rgba(theme.colors.lightblue[6], 0.2)}
          highlightTextColor={theme.colors.dark[6]}
          fontWeight={500}
        />
      </div>
      <div className={classes.footer}>
        <Avatar
          src={avatarUrl}
          className={classes.avatar}
          alt={name}
          color="lightblue"
        >
          {getInitials(name)}
        </Avatar>
        <div className={classes.meta}>
          <Text className={classes.name}>{name}</Text>
          <Text className={classes.role}>{role}</Text>
        </div>
      </div>
    </Card>
  );
}
